import React, { Component } from "react"

export default class ResponsiveTable extends Component {
  componentDidMount = () => {
    this.initialiseTable()
  }

  componentDidUpdate = (prevProps) => {
    this.initialiseTable()
  }

  initialiseTable = () => {
    if (!("Tablesaw" in window)) {
      console.log("Unable to load Tablesaw script")
      return
    }

    window.Tablesaw.init(this.tableRef)
  }

  render() {
    return (
      <table
        className="tablesaw tablesaw-stack"
        data-tablesaw-mode="stack"
        ref={(el) => {
          this.tableRef = el
        }}
      >
        {this.props.children}
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/themed-html-components/ResponsiveTable.jsx